import { colors } from '../../colors';
var imageSlider = {
  primaryBgColor: colors.white,
  secondaryBgColor: colors.offWhite,
  textColorDark: colors.charcoalGrey,
  textColorLight: colors.white
};
export default imageSlider;